import { ButtonHTMLAttributes, ReactNode } from "react";
import "./index.css";
import ReactLoading from "react-loading";

type MainButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text: string | ReactNode;
  backgroundColor: string;
  border?: string;
  icon?: ReactNode;
  bold?: string;
  color: string;
  fontSize?: string;
  loaderIcon?: boolean;
  height?: string;
};

export function MainButton({
  text,
  color,
  backgroundColor,
  border,
  icon,
  fontSize,
  bold,
  loaderIcon,
  height,
  ...props
}: MainButtonProps) {
  return (
    <button
      {...props}
      className="main-button"
      style={{
        color,
        backgroundColor,
        border: border ? border : "none",
        height: height ? height : "",
      }}
    >
      {icon && icon}
      <span
        style={{
          fontWeight: `${bold ? bold : ""}`,
          fontSize: fontSize ? fontSize : "",
          color,
        }}
      >
        {" "}
        {text}
      </span>
      {loaderIcon && (
        <ReactLoading
          type={"spin"}
          color={"#FFFFFF"}
          height={"25px"}
          width={"25px"}
        />
      )}
    </button>
  );
}
